<p-toast [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<p-confirmDialog header="Confirmation"></p-confirmDialog>
<div class="absolute top-0 left-0 w-full p-3">

    <p-toolbar>
        <div class="p-toolbar-group-left">
            <div i18n="@@appointment-configuration.title" class="text-xl font-semibold">Configuration</div>
        </div>
        <div class="p-toolbar-group-right text-lg font-semibold">
            <p-button icon="far fa-times" [text]="true" severity="secondary" [routerLink]="['/']"></p-button>
        </div>
    </p-toolbar>

    <p-message severity="info">
        <ng-template pTemplate>
            <div class="flex flex-row justify-content-between w-full">
                <span class="externalSourceSpan"
                    i18n="@@appointment-configuration.application-configuration.calendarsMoved">The configuration tab has been moved to the CMS. In the “Appointment Settings” tab of the appointment module, individual calendars can be activated for the respective module. Embeded codes and the shown timeframe can also be created / changed here  Calendars, locations and registration forms can be created, edited and deleted under the “Calendar” tab.</span>
            </div>
        </ng-template>
    </p-message>
</div>